import React, { useCallback, useEffect, useRef, useState } from "react";
import "./clients.scss";
import isEmpty from "lodash/isEmpty";
import { Link, useHistory, useLocation } from "react-router-dom";
import { useWindowSize } from "../../utils/useWindowResize";
import { sortEveryNth } from "../../utils/sortEveryNth";
import { ReactComponent as LongRightArrow } from "../../assets/images/icons/long-right-arrow.svg";
import { getAllUrlParams } from "../../utils/getAllUrlParams";

import Gallery from "react-grid-gallery";
import Footer from "../commons/footer";
import grid1 from "../../assets/images/community-works/1.png";
import grid2 from "../../assets/images/community-works/2.png";
import grid3 from "../../assets/images/community-works/3.png";
import axios from "axios";
import { truncate } from "../../utils/truncateString";
import { Spinner } from "react-bootstrap";
import { Helmet } from "react-helmet";

const GalleryWrapper = (props) => {
  return (
    <div {...props} className="gallery-wrapper cw-gallery-wrapper">
      {props.children}
    </div>
  );
};

const GalleryImage = (props) => {
  return (
    <div
      className={`gallery-image-wrapper gallery-image-wrapper-${
        props.index + 1
      }`}
    >
      <div
        className="gallery-image"
        style={{
          background: `linear-gradient(
            rgba(0, 0, 0, 0.5),
            rgba(0, 0, 0, 0.5)
          ),url('${props.data.client_image_url}')`,
        }}
      >
        <p>{props.data.name}</p>
        <Link to={`/clients/${props.data.id}`}>
          <p className="very-bold">
            Read more &nbsp;
            <LongRightArrow />
          </p>
        </Link>
      </div>
    </div>
  );
};

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const Clients = () => {
  const [width] = useWindowSize();
  const [readMore, setReadMore] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [cwData, setCWData] = useState([]);
  const [paginationLinks, setPaginationLinks] = useState({});
  const [sortedImageData, setSortedImageData] = useState([]);

  const history = useHistory();

  const query = useQuery();
  const pageNumber = query.get("page") ?? 1;
  console.log("pageNumber", +pageNumber);

  useEffect(() => {
    loadCommunityWorks();
  }, []);

  useEffect(() => {
    if (width > 1366) {
      setSortedImageData(sortEveryNth(cwData, 5));
    } else if (width > 1024 && width <= 1366) {
      setSortedImageData(sortEveryNth(cwData, 3));
    } else if (width > 800 && width <= 1024) {
      setSortedImageData(sortEveryNth(cwData, 2));
    } else {
      setSortedImageData(cwData);
    }
  }, [width, cwData]);

  const loadCommunityWorks = async () => {
    try {
      setIsLoading(true);
      const response = await axios.get(
        `https://admin.bdicofficial.com/api/clients?page=${[pageNumber]}`
      );
      const publishedPosts = response.data?.data.filter(
        (post) => post.is_published
      );
      setCWData(publishedPosts ?? []);
      setPaginationLinks(response.data?.links);
      setIsLoading(false);
    } catch (error) {
      alert(
        `An error occured while fetching community works - ${error.message}`
      );
      setIsLoading(false);
    }
  };

  const description = () => {
    const textToDisplay = `"We see our customers as invited guests to a party, and we are the hosts. It’s our job every day to make every important aspect of the customer experience a little bit better." ― Jeff Bezos`;

    // return !readMore ? truncate(textToDisplay, 230) : textToDisplay;
    return textToDisplay;
  };

  const createDescriptionMarkup = () => {
    return { __html: description() };
  };

  const readMoreText = !readMore ? "See more" : "See less";

  const handleOnReadMore = () => {
    setReadMore(!readMore);
  };

  const onRightButtonClick = () => {
    const getParams = getAllUrlParams(paginationLinks.next);
    history.push(`/clients?page=${getParams.page ?? 1}`);
    window.location.reload();
  };

  const onLeftButtonClick = () => {
    if (!isEmpty(paginationLinks.prev)) {
      const getParams = getAllUrlParams(paginationLinks.prev);
      history.push(`/clients?page=${getParams.page ?? 1}`);
      window.location.reload();
    }
  };

  return (
    <>
      <div className="app-container">
        <div className="page-wrapper">
          <div className="community-work-section">
            <div className="community-work-header-section">
              <h1 className="community-work-header-title">Clients</h1>

              <div>
                <p
                  className="community-work-header-description"
                  dangerouslySetInnerHTML={createDescriptionMarkup()}
                ></p>
                {/* <a className="very-bold" href onClick={handleOnReadMore}>
                  {readMoreText}
                </a> */}
              </div>
            </div>
            {isLoading && (
              <Spinner animation="grow" role="status">
                <span className="sr-only">Loading...</span>
              </Spinner>
            )}
            {!isEmpty(sortedImageData) && (
              <GalleryWrapper>
                {sortedImageData.map((data, index) => (
                  <GalleryImage key={data.id} data={data} index={index} />
                ))}
              </GalleryWrapper>
            )}
          </div>
        </div>
      </div>
      <Footer
        className="sticky"
        showRightArrow={paginationLinks?.next !== null}
        showLeftArrow={paginationLinks?.prev !== null}
        onRightButtonClick={onRightButtonClick}
        onLeftButtonClick={onLeftButtonClick}
        rightArrowClass="live-right-arrow"
        leftArrowClass="live-left-arrow"
      />
    </>
  );
};

export default Clients;
